export default "__VITE_ASSET__cd7ded79__"